import React from "react";
import Reveal from "./Reveal";

const REVIEWS = [
  {
    name: "Mariya Vazhelyuk",
    text:
      "Late last year I was hit by a U-Haul truck. My friend told me to call Jared. He and his team made it possible for me to get the settlement check for my injuries — easier than I thought it would be. Every person on the team is professional and knowledgeable.",
    location: "Google Review",
  },
  {
    name: "Sade Hossain",
    text:
      "Beyond satisfied with Jared as my attorney. The best in South Florida! He was always available, super kind, and kept me informed every step of the way. He worked very hard on my case — I recommend him to everybody.",
    location: "Google Review",
  },
  {
    name: "Izik Gargir",
    text:
      "Hired Jared to help me with my car accident. He helped me fix my car and guided me through the entire process. Can't thank him and his team enough.",
    location: "Google Review",
  },
  {
    name: "Petit-Richard Pierre",
    text:
      "Absolutely wonderful. I got in a car accident about a year and a half ago — very helpful and informative throughout the entire process. I would recommend.",
    location: "Google Review",
  },
];

const Stars = () => (
  <div className="flex items-center gap-1 text-[#B89968]" aria-label="5 out of 5 stars">
    {[0, 1, 2, 3, 4].map((i) => (
      <svg key={i} width="16" height="16" viewBox="0 0 20 20" fill="currentColor">
        <path d="M10 1.5l2.6 5.27 5.82.85-4.21 4.1.99 5.79L10 14.77 4.8 17.51l.99-5.79L1.58 7.62l5.82-.85L10 1.5z" />
      </svg>
    ))}
  </div>
);

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="relative bg-[#0F2240] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <Reveal className="text-center max-w-2xl mx-auto mb-16 md:mb-20">
          <div className="flex items-center justify-center gap-3 mb-5">
            <div className="h-px w-10 bg-[#B89968]" />
            <span className="text-[#B89968] text-xs uppercase tracking-[0.32em]">
              5-Star Reviews
            </span>
            <div className="h-px w-10 bg-[#B89968]" />
          </div>
          <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-white leading-tight">
            Trusted by clients <span className="italic gold-text">across Florida.</span>
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8">
          {REVIEWS.map((r, i) => (
            <Reveal
              key={r.name}
              delay={i * 80}
              className="bg-[#15294C] border border-[#B89968]/15 p-8 md:p-10 hover:border-[#B89968]/40 transition-colors duration-500"
              data-testid={`testimonial-${i}`}
            >
              <div className="flex items-center justify-between mb-5">
                <Stars />
                <span className="text-xs uppercase tracking-[0.22em] text-[#64748B]">
                  {r.location}
                </span>
              </div>
              <blockquote className="text-[#E2E8F0] text-base md:text-lg leading-relaxed mb-6 italic">
                "{r.text}"
              </blockquote>
              <div className="flex items-center gap-3 pt-5 border-t border-[#B89968]/10">
                <div className="w-10 h-10 rounded-full bg-[#B89968]/15 flex items-center justify-center text-[#B89968] font-serif-display text-lg">
                  {r.name.charAt(0)}
                </div>
                <div>
                  <div className="font-serif-display text-white">{r.name}</div>
                  <div className="text-xs text-[#94A3B8] uppercase tracking-wider">
                    Verified Client
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
